import { CompanyGroupRoleModel } from 'app/models/companyGroupRoleModel'
import { UserModel } from 'app/models/userModel'

export const getRolesInfo = (
  userInfo: UserModel,
): Array<CompanyGroupRoleModel> => {
  if (userInfo.roles == null) {
    return []
  }

  const companyRolesInfo: Array<CompanyGroupRoleModel> =
    getAggregatedCompanyRoles(userInfo)
  const groupRolesInfo: Array<CompanyGroupRoleModel> =
    getAggregatedGroupRoles(userInfo)

  const rolesInfo = [...companyRolesInfo, ...groupRolesInfo]
  return rolesInfo
}

const getAggregatedCompanyRoles = (userInfo: UserModel) => {
  const groupedCompanyRoles = userInfo.roles.reduce((accumulated, current) => {
    if (!accumulated[current.company.name])
      accumulated[current.company.name] = []
    accumulated[current.company.name].push(current)
    return accumulated
  }, {})
  const rolesInfo: Array<CompanyGroupRoleModel> = Object.keys(
    groupedCompanyRoles,
  ).map((key) => {
    return {
      object: {
        name: groupedCompanyRoles[key][0].company.name,
        id: groupedCompanyRoles[key][0].company.id,
      },
      roles: groupedCompanyRoles[key][0].company.roles,
    }
  })
  return rolesInfo
}

const getAggregatedGroupRoles = (userInfo: UserModel) => {
  const groupedRoles = userInfo.groups.reduce((accumulated, current) => {
    if (!accumulated[current.group.name]) accumulated[current.group.name] = []
    accumulated[current.group.name].push(current)
    return accumulated
  }, {})
  const rolesInfo: Array<CompanyGroupRoleModel> = Object.keys(groupedRoles).map(
    (key) => {
      return {
        object: {
          name: groupedRoles[key][0].group.name,
          id: groupedRoles[key][0].group.id,
          isGroup: true,
        },
        roles: groupedRoles[key][0].roles,
      }
    },
  )
  return rolesInfo
}
